interface IFeatureFlags {
  CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: boolean
  ALLOW_OLD_PREVIEW_PAGE: boolean
}

const configuration: Record<string, IFeatureFlags> = {
  development: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: true,
  },
  staging: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: true,
  },
  interop: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: true,
  },
  beta: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: true,
  },
  production: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: true,
  },
}

export const featureFlags =
  configuration[(process.env.mode || process.env.NODE_ENV) as string]
